module.exports = __webpack_public_path__ + "static/img/loader.1d4cf57.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lekkerhot/loader.gif
// module id = Yi1G
// module chunks = 0